module.exports = __webpack_public_path__ + "img/file-contract.d110ceda.svg";